<template>
    <div class="image-upload-component clearfix" :class="(readOnly && 'read-only') +  selfWidth && ' w154'">
        <a-upload
        :accept="accept"
        :listType="listType"
        :fileList="fileList"
        :customRequest="ossUploader"
        :beforeUpload="beforeUpload"
        :multiple="multiple"
        @preview="handlePreview"
        @change="handleChange"
        
        name="file"
        >
            <template v-if="listType === 'picture-card'">
                <div v-if="!readOnly && (fileList.length < limitNum)">
                    <a-icon type="plus" />
                    <div class="ant-upload-text">上传图片</div>
                    <div class="ant-upload-text no-margin_top">{{pxSize}}</div>
                </div>
            </template>
            <template v-else-if="listType === 'text'">
                <a-button v-if="!readOnly && (fileList.length < limitNum)">
                    <a-icon type="upload" /> 上传图片
                </a-button>
            </template>
        </a-upload>
        <a-modal :width="1000" :visible="previewVisible" :footer="null" @cancel="handleCancel">
            <div class="pt16 pb16 pr16 pl16">
                <img style="width: 100%" :src="previewImage" />
            </div>
        </a-modal>
    </div>
</template>

<script type="text/javascript">
    export default {
        name: "images-upload",
        zn: '多张图片上传组件',
        components: {

        },
        props: {
            readOnly: {
                type: Boolean,
                default: false
            },
            limitNum: {
                type: Number,
                default: Infinity
            },
            moduleKey: {
                type: String,
                default: '/images'
            },
            pxSize: {
                type: String,
                // default: '尺寸不小于900px*500px'
                default: '建议尺寸1125*630'
            },
            listType: {
                type: String,
                default: 'picture-card'
            },
            selfWidth: {
                type: Boolean,
                default: false
            },
            multiple: {
                type: Boolean,
                default: false
            },
        },
        data() {
            return {
                previewVisible: false,
                previewImage: '',
                fileList: [],
                accept: 'image/jpeg,image/png',
                limit: 10,
                unit: 'MB',
                imgKey: '',
            }
        },
        methods: {
            // 上传之前验证
            beforeUpload(file) {
                const typeLimit = this.accept.split(',').some(_type => file.type === _type);
                if (!typeLimit) {
                    this.$message.error('请上传格式正确的图片');
                }
                let sizeLimit;
                if (this.unit === 'MB' || this.unit === 'M') {
                    sizeLimit = file.size / 1024 / 1024 < this.limit;
                }
                else {
                    sizeLimit = file.size / 1024 < this.limit;
                }
                if (!sizeLimit) {
                    this.$message.error(`请使用小于${this.limit}${this.unit}的图片!`);
                }
                let result = sizeLimit && typeLimit;
                return result;
            },
            ossUploader({ onProgress, onSuccess, onError, file }) {
                this.$api.common.getOssKey().then(res => {
                    const formData = new FormData();
                    const body = {
                        key: `images/${file.lastModified}_${file.name}`,
                        OSSAccessKeyId: res.accessKeyId,
                        policy: res.policy,
                        Signature: res.signature,
                        success_action_status: '200',
                        file
                        // callback: data.callbackFunName,
                    };
                    Object.keys(body).forEach(key => formData.append(key, body[key]));
                    return this.$api.common.ossUpload({
                            body: formData
                        }, {
                            headers: {
                                'Content-Type': 'multipart/form-data'
                            },
                            onUploadProgress: ({ total, uploaded }) => {
                                onProgress({ percent: uploaded / total * 100 });
                            }
                        });
                }).then((ossRes) => {
                    onSuccess();
                    this.fileList.forEach(item => {
                        item.url = `https://apailang.oss-cn-hangzhou.aliyuncs.com/images/${item.lastModified}_${item.name}`
                    })
                }).catch(err => {
                    onError(err);
                })
            },
            handleCancel () {
                this.previewVisible = false;
            },
            handlePreview (file) {
                this.previewImage = file.url || file.thumbUrl;
                this.previewVisible = true;
            },
            handleChange ({ fileList }) {
                this.fileList = fileList;
            },
        },
        mounted() {
        }
    }
</script>

<style rel="stylesheet/scss" lang="scss">
    .image-upload-component{
        .ant-upload-picture-card-wrapper {
            .ant-upload-select-picture-card i {
                font-size: 32px;
                color: #999;
            }
            .ant-upload-select-picture-card .ant-upload-text {
                margin-top: 8px;
                color: #666;
            }
            .ant-upload-list-picture-card-container,
            .ant-upload-list-item,
            .ant-upload-select-picture-card {
                width: 230px;
                height: 128px;
            }
            .ant-upload-list-item-actions {
                .anticon {
                    font-size: 24px;
                    margin: 0 10px!important;
                }
            }
        }
        &.read-only {
            .anticon.anticon-delete{
                display: none!important;
            }
        }
    }
    .w154 {
        .ant-upload-list-picture-card-container,
        .ant-upload-list-item,
        .ant-upload-select-picture-card {
            width: 154px !important;
        }
    }

</style>
